<template>
  <v-container fluid>
    <v-layout align-start justify-end row wrap>
      <v-flex xs12 md8>
        <v-timeline v-if="pronostics.length">
          <v-timeline-item
            v-for="prono in pronostics"
            :key="prono.id"
            color="red lighten-2"
            large
          >
            <span slot="opposite">{{ convertDate(prono.updated) }}</span>
              <v-card class="elevation-2" width="300">
                <v-btn style="position: absolute; right: -25px; top: -25px;" color="red" dark v-if="isParent" @click="$emit('delete', prono.id)" icon>
                    <v-icon>close</v-icon>
                </v-btn>
                  <v-card-title>
                      <Profile :profile="users[prono.id]" :width="125" />
                      <v-spacer />
                      <v-menu
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                      >
                          <v-btn icon slot="activator"><v-icon>event</v-icon></v-btn>
                              <v-date-picker
                                  :value="convertDate(prono.date)"
                                  no-title
                                  readonly=""
                                  scrollable
                              >
                          </v-date-picker>
                      </v-menu>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text style="position: relative;">
                      <Viewer 
                          :weight="prono.weight"
                          :height="prono.height"
                          :gender="prono.gender"
                          :color="prono.color"/>
                      <v-expand-transition>
                          <div
                              class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                              style="position: absolute; left: 0px; top: 0px; height: 100%; width: 100%; opacity: 0.3;">
                              <v-list>
                                  <v-list-tile>
                                      {{ prono.gender}}
                                  </v-list-tile>
                                  <v-list-tile>
                                      {{ prono.weight / 1000}}kg
                                  </v-list-tile>
                                  <v-list-tile>
                                      {{ prono.height}}cm
                                  </v-list-tile>
                              </v-list>
                          </div>
                          </v-expand-transition>
                  </v-card-text>
              </v-card>
          </v-timeline-item>
        </v-timeline>
        <v-alert
          v-else
          :value="true"
          color="info"
          icon="info"
          outline
        >
          No pronostic yet !
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Viewer from "@/components/baby/Viewer";
import Profile from "@/components/user/Profile";

export default {
  props: {
    pronos: Array,
    isParent: Boolean,
    users: Object
  },
  computed: {
    pronostics() {
      return this.pronos.sort((a, b) => {
        if (a.updated && b.updated) {
          return a.updated.seconds - b.updated.seconds
        } else {
          return 0
        }
      })
    }
  },
  methods: {
    convertDate(date) {
      if (date) {
        return new Date(date.seconds * 1000).toISOString().split("T")[0];
      }
    }
  },
  components: {
    Viewer, Profile
  }
};
</script>
